'use-client';

import React from 'react';
import {
  Progress as NextUIProgress,
  ProgressProps as TNextUIProgressProps,
} from '@nextui-org/react';

/* ================================== TYPES ================================= */

export type TProgressBarProps = TNextUIProgressProps;

/* ========================================================================== */
/*                                  COMPONENT                                 */
/* ========================================================================== */
export function ProgressBar(props: TProgressBarProps) {
  return <NextUIProgress {...props} />;
}
